import { render } from "./PantryDetailDataValue.vue?vue&type=template&id=22ce74f4&ts=true"
import script from "./PantryDetailDataValue.vue?vue&type=script&lang=ts"
export * from "./PantryDetailDataValue.vue?vue&type=script&lang=ts"

import "./PantryDetailDataValue.vue?vue&type=style&index=0&id=22ce74f4&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__